import { Box, Grid, Stack, Typography } from "@mui/material";
import { useMediaQuery } from "@uidotdev/usehooks";
import React from "react";
import { Fade } from "react-awesome-reveal";
import ButtonLearn from "../../Button/ButtonLearn";

import { Trans, useTranslation } from "react-i18next";

type Props = {};

const BrochureAtom1 = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(min-width: 768px)");

  return (
    <div
      style={{
        width: "80vw",
      }}
    >
      {" "}
      <Grid
        paddingBottom={isMobile ? 3 : 1}
        pt={isMobile ? undefined : 5}
        sx={{ flexDirection: isMobile ? "column" : "row" }}
        container
      >
        <Grid
          item
          xs={12}
          md={isTablet ? 12 : 6}
          style={{
            flex: 1,
          }}
        >
          <Typography
            variant="body1"
            letterSpacing="0.7px"
            lineHeight={isMobile ? "22px" : isTablet && isMobile ? 1.5 : "28px"}
            fontSize={
              isMobile ? "14px" : isTablet && isMobile ? "18px" : "14px"
            }
          >
            <Trans
              i18nKey="brochure_section_1"
              components={{
                bold: <b style={{ fontWeight: 500 }} />,
                italic: <i />,
              }}
            />
          </Typography>
        </Grid>
        {isMobile && (
          <>
            <img
              src={"pic"}
              alt="Brochure residenza storica"
              style={{
                margin: "20px 0",
                width: "100%",
                objectFit: "contain",
              }}
            />
            <BrochureCards />
            <Box width="100%" height={"25vh"}>
              <img
                src={"maps"}
                alt=""
                style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "100%",
                }}
              />
            </Box>{" "}
          </>
        )}
        <Grid item xs={12} md={6} style={{ flex: 1 }}>
          <Box
            height={215}
            sx={{
              paddingLeft: isMobile ? undefined : "30px",
              paddingTop: isMobile ? "20px" : undefined,
            }}
          >
            <Typography
              variant="body1"
              letterSpacing="0.7px"
              lineHeight={
                isMobile ? "22px" : isTablet && isMobile ? 1.5 : "28px"
              }
              fontSize={
                isMobile ? "14px" : isTablet && isMobile ? "18px" : "14px"
              }
            >
              <Trans
                i18nKey="brochure_section_2"
                components={{
                  bold: <b style={{ fontWeight: 500 }} />,
                  italic: <i />,
                }}
              />
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

const BrochureAtom2 = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 768px)");

  return (
    <Stack
      spacing={isTablet ? 6 : 3}
      height={isTablet ? "100%" : "auto"}
      width={isMobile || isTablet ? "80%" : "100%"}
      alignItems={"center"}
      paddingRight={"0"}
      justifyContent={isTablet ? "flex-start" : "center"}
    >
      <Typography
        letterSpacing="0.7px"
        variant={isMobile ? "body2" : "subtitle2"}
        lineHeight={isMobile ? "22px" : isTablet ? 1.5 : "24px"}
        fontSize={isMobile ? "14px" : isTablet ? "18px" : "14px"}
        fontWeight="400"
      >
        <Trans
          i18nKey="brochure_section_4"
          components={{
            bold: <b />,
            italic: <i />,
          }}
        />
      </Typography>
      <Fade
        style={{
          display: isMobile ? "none" : "block",
          marginTop: isMobile ? undefined : 30,
          marginLeft: isMobile ? undefined : 100,
        }}
        direction="left"
      >
        <ButtonLearn text="CONTATTACI" isLink />
      </Fade>
    </Stack>
  );
};

const BrochureAtom3 = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 1000px)");

  return (
    <Typography
      paddingBottom={isMobile ? 2 : 0}
      letterSpacing="0.7px"
      variant={isMobile ? "body2" : "subtitle2"}
      lineHeight={isMobile ? "20px" : "20px"}
      fontSize={isMobile ? "12px" : "14px"}
      fontWeight="400"
    >
      <Trans
        i18nKey="brochure_section_3"
        components={{ bold: <b style={{ fontWeight: 500 }} />, italic: <i /> }}
      />
    </Typography>
  );
};

const BrochureAtom31 = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 965px)");

  return (
    <Typography
      paddingBottom={isMobile ? 2 : 0}
      letterSpacing="0.7px"
      variant={isMobile ? "body2" : "subtitle2"}
      lineHeight={isMobile ? "20px" : "3.75vh"}
      fontSize={isMobile ? "12px" : "18px"}
      fontWeight="400"
      sx={{
        color: isMobile ? undefined : isTablet ? "#fff" : undefined,
      }}
    >
      <Trans
        i18nKey="brochure_section_31"
        components={{ bold: <b style={{ fontWeight: 500 }} />, italic: <i /> }}
      />
    </Typography>
  );
};
const BrochureInfo = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 965px)");

  return (
    <Typography
      paddingBottom={isMobile ? 2 : 0}
      letterSpacing="0.7px"
      variant={isMobile ? "body2" : "subtitle2"}
      lineHeight={isMobile ? "20px" : "3.75vh"}
      fontSize={isMobile ? "12px" : "18px"}
      fontWeight="400"
      sx={{
        color: isMobile ? undefined : isTablet ? "#fff" : undefined,
      }}
    >
      <Trans
        i18nKey="brochure_section_info"
        components={{ bold: <b style={{ fontWeight: 500 }} />, italic: <i /> }}
      />
    </Typography>
  );
};

const BrochureAtom32 = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 768px)");

  return (
    <Typography
      paddingBottom={isMobile ? 2 : 0}
      letterSpacing="0.7px"
      variant={isMobile ? "body2" : "subtitle2"}
      lineHeight={isMobile ? "20px" : "3.75vh"}
      fontSize={isMobile ? "12px" : "18px"}
      fontWeight="400"
      textAlign={isMobile || isTablet ? undefined : "right"}
    >
      <Trans
        i18nKey="brochure_section_32"
        components={{ bold: <b style={{ fontWeight: 500 }} />, italic: <i /> }}
      />
    </Typography>
  );
};

const BrochureAtom4 = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 768px)");

  return (
    <Typography
      paddingBottom={isMobile ? 2 : 8}
      letterSpacing="0.7px"
      variant={isMobile ? "body2" : "subtitle2"}
      lineHeight={isMobile ? "22px" : "3.75vh"}
      fontSize={isMobile ? "14px" : isTablet ? "18px" : "14px"}
      fontWeight="400"
      textAlign={isMobile ? "center" : "start"}
    >
      <Trans
        i18nKey="brochure_section_5"
        components={{ bold: <b />, italic: <i /> }}
      />
    </Typography>
  );
};

const BrochureRooms2 = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Typography
      variant="body1"
      lineHeight={"3.75vh"}
      fontSize={"16px"}
      marginBottom={2}
      color={isMobile ? undefined : "white"}
    >
      <Trans
        i18nKey="brochure_rooms2"
        components={{
          bold: <b />,
          italic: <i />,
        }}
      />
    </Typography>
  );
};
const BrochureCucina1 = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Typography
      variant="subtitle2"
      fontWeight="400"
      letterSpacing={"0.4px"}
      lineHeight={"3.75vh"}
      fontSize={"14px"}
      color={isMobile ? "black" : "white"}
      sx={{
        transform: "translate(0, -1vw)",
      }}
    >
      <Trans
        i18nKey="brochure_section_91"
        components={{
          bold: <b style={{ fontWeight: 500 }} />,
          italic: <i />,
        }}
      />
    </Typography>
  );
};
const BrochureCucina2 = (props: Props) => {
  return (
    <Typography
      variant="subtitle2"
      fontWeight="400"
      letterSpacing={"0.4px"}
      lineHeight={"3.75vh"}
      fontSize={"14px"}
      sx={{
        transform: "translate(0, -1vw)",
      }}
    >
      <Trans
        i18nKey="brochure_section_92"
        components={{
          bold: <b style={{ fontWeight: 500 }} />,
          italic: <i />,
        }}
      />
    </Typography>
  );
};
const BrochureAtom5 = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 768px)");

  return (
    <Typography
      paddingBottom={isMobile ? 2 : isTablet ? 3.5 : 8}
      letterSpacing="0.7px"
      variant={isMobile ? "body2" : "subtitle2"}
      lineHeight={isMobile ? "22px" : isTablet ? 1.5 : "28px"}
      fontSize={isMobile ? "14px" : isTablet ? "18px" : "14px"}
      fontWeight="400"
      textAlign={isMobile ? "center" : "start"}
    >
      <Trans
        i18nKey="brochure_section_6"
        components={{ bold: <b />, italic: <i /> }}
      />
    </Typography>
  );
};

const BrochureAtom6 = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 1000px)");

  return (
    <Stack
      height={"100%"}
      width={isMobile ? "80%" : "40%"}
      alignItems={"center"}
      paddingRight={"0"}
      justifyContent={"flex-start"}
      paddingTop={isMobile ? 2 : 12}
    >
      <Typography
        letterSpacing="0.7px"
        variant={isMobile ? "body2" : "subtitle2"}
        lineHeight={isMobile ? "20px" : "28px"}
        fontSize={isMobile ? "12px" : "14px"}
        fontWeight="400"
        textAlign={isMobile ? "left" : "right"}
        paddingLeft={isMobile ? undefined : "250px"}
      >
        <Trans
          i18nKey="brochure_section_8"
          components={{
            bold: <b />,
            italic: <i />,
          }}
        />
      </Typography>
    </Stack>
  );
};

const BrochureCards = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 1000px)");
  const { t } = useTranslation();
  return (
    <Box width={isMobile ? "100%" : "90vw"}>
      <Typography
        sx={{
          display: isMobile ? "block" : "none",
          textAlign: "center",
          margin: "0 auto",
          fontStyle: "italic",
          fontSize: "12px",
        }}
      >
        {t("resOffre")}
      </Typography>
    </Box>
  );
};

const BrochureAtom7 = (props: Props) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const isTablet = useMediaQuery("(max-width: 768px)");
  return (
    <Box
      width={isMobile || isTablet ? "90%" : "80%"}
      padding={isMobile ? "20px" : "40px"}
      margin="0 auto"
    >
      <Typography
        sx={{
          paddingBottom: isMobile ? 2.5 : 4,
          color: isTablet ? "#000" : "#1f5f91",
          fontFamily: "ivymode",
          letterSpacing: isMobile ? undefined : "2px",
        }}
        variant={isMobile ? "h3" : "subtitle2"}
        lineHeight={isMobile ? "22px" : isTablet ? 1.5 : "28px"}
        fontSize={isMobile ? "20px" : isTablet ? "24px" : "36px"}
        fontWeight="300"
        textAlign="center"
      >
        <Trans
          i18nKey="brochure_rooms1"
          components={{
            bold: <b />,
            italic: <i />,
          }}
        />{" "}
      </Typography>
      <Typography
        variant="body1"
        lineHeight={isMobile ? "22px" : isTablet ? 1.5 : "28px"}
        fontSize={isMobile ? "14px" : isTablet ? "16px" : "16px"}
        fontWeight="400"
        textAlign="center"
        marginBottom={2}
      >
        <Trans
          i18nKey="brochure_rooms2"
          components={{
            bold: <b />,
            italic: <i />,
          }}
        />
      </Typography>
    </Box>
  );
};

export {
  BrochureAtom1,
  BrochureCucina1,
  BrochureCucina2,
  BrochureAtom2,
  BrochureAtom3,
  BrochureAtom31,
  BrochureAtom32,
  BrochureAtom4,
  BrochureAtom5,
  BrochureAtom6,
  BrochureAtom7,
  BrochureCards,
  BrochureRooms2,
  BrochureInfo,
};
